import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import { selectIntentManagementSlice } from "app/pages/workspace/sales/store/selectors";
import { createSelector } from "reselect";
import type { Topic } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

const select = createStatePropertySelector(selectIntentManagementSlice);

export const selectIntentSearchObject = select("searchObj");

export const selectIntentCategories = select("categories");
export const selectIntentTopics = select("topics");
export const selectIntentTopicsTotalCount = select("totalCount");
export const selectIntentSelectedTopics = select("selectedTopics");

export const selectIntentSaveTopicsError = select("saveTopicsError");
export const selectIsTopicFetching = select("isTopicsFetching");
export const selectIsTopicFetchError = select("topicsFetchError");

export const selectIsSelectedTopicFetching = select("isSelectedTopicsFetching");
const selectIsSelectedTopicFetchError = select("selectedTopicsFetchError");

export const selectIsLocked = select("isLocked");

export const selectIsUserApprovedTerms = select("isUserApprovedTerms");

const selectContactAdmins = select("contactAdmins");
export const selectIsUserApprovedTermsFetched = select("isUserApprovedTermsFetched");
const selectCreatedAtDate = select("createdAt");
export const selectIsScrollSelectedTopic = select("isScrollSelectedTopic");

export const selectIsSelectedIntentTopicsOverLimit = createSelector(
    selectIntentSelectedTopics,
    (selectedTopics: readonly Topic[]) => {
        const numIntentTopics: number = salesSettingsHelper.getNumIntentTopics();
        return selectedTopics.length > numIntentTopics;
    },
);
